import React, { useContext } from 'react'
import styled from 'styled-components'
import { LegalDepositsContext } from 'contexts/LegalDepositsContext'
import EmptyDeposits from './EmptyDeposits'
import DepositPanel from './DepositPanel'

const DepositsList = () => {
  const { deposits } = useContext(LegalDepositsContext)

  if (deposits.length === 0) return <EmptyDeposits />

  return (
    <div>
      <ListHeader>
        <SectionTitle>Dépôts ({deposits.length})</SectionTitle>
      </ListHeader>
      <DepositsContainer>
        {deposits.map((deposit, index) => (
          <DepositPanel
            key={deposit.id}
            deposit={deposit}
            defaultOpen={index === 0}
          />
        ))}
      </DepositsContainer>
    </div>
  )
}

export default DepositsList

// ─── Styles ───────────────────────────────────────────────────────────────────

const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

const SectionTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: #171a1c;
`

const DepositsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 8px;
  overflow: hidden;
`
